var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M16,9.52l1.61,3.25.46,1,1,.15,3.59.52-2.6,2.53-.75.73.18,1,.61,3.58-3.21-1.69L16,20.09l-.93.49-3.21,1.69.61-3.58.18-1-.75-.73L9.3,14.39l3.59-.52,1-.15.46-1L16,9.52M16,5l-3.4,6.89L5,13l5.5,5.36L9.2,25.92,16,22.35l6.8,3.57-1.3-7.57L27,13l-7.6-1.1L16,5Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }